import { createContext } from "react";

const TasksStateContext = createContext();

export default TasksStateContext;
